import { Injectable } from '@angular/core';

declare var signalR;

@Injectable({
providedIn: 'root',
})
export class SignalRService {
    constructor() {}

    buildRoutingClient(onBroadcastPing: (connectionId: string, name: string, userId: string, phoneNumber: string, email: string) => void,
        onLeave: (connectionId: string) => void, onVersionChange: (version: string) => void) {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl('/hubs/routing')
            .withAutomaticReconnect()
            .build();

        connection.on('RequestPing', () => {
            connection.send('ReceivePing');
        });

        connection.on('BroadcastPing', onBroadcastPing);
        connection.on('OnLeave', onLeave);
        connection.on('OnVersionChange', onVersionChange);

        return connection;
    }
}